<template>
  <div>
    <Row :gutter="20" type="flex" class="grid-list-row mx-0">
      <Col
        :span="column.colSpan"
        align="middle"
        v-for="(column, index) in sectionHeader"
        :key="index"
      >
        <span v-if="getBidDetails[column.label]">
          <span v-if="column.label === 'order_no'">
            <p>
              <span>{{
                getBidDetails[column.tlabel]
                  ? getBidDetails[column.tlabel]
                  : getBidDetails[column.label]
              }}</span>
              <small v-if="getBidDetails.created_at">
                {{ getBidDetails.created_at }}
              </small>
            </p>
          </span>
          <span v-else-if="column.label === 'vehicle_type'">
            <p>
              <span>{{
                hasRequestedVehicle
                  ? requestedVehicle.name
                  : getBidDetails[column.tlabel]
                  ? getBidDetails[column.tlabel]
                  : getBidDetails[column.label]
              }}</span>
              <small v-if="getBidDetails.vechile_req_date">
                {{ getBidDetails.vechile_req_date }}
              </small>
            </p>
          </span>
          <span v-else-if="column.tooltip">
            <Tooltip
              effect="dark"
              placement="bottom"
              v-if="getBidDetails[column.label].tooltipText"
            >
              <div slot="content">
                {{ getBidDetails[column.label].tooltipText }}
              </div>
              <span>{{ getBidDetails[column.label].value }}</span>
            </Tooltip>
            <span v-else>{{ getBidDetails[column.label].value }}</span>
          </span>
          <span v-else>{{ getBidDetails[column.label] }}</span>
        </span>
        <span v-else> - </span>
      </Col>
      <Col align="middle" class="col-push text-right">
        <span
          class="badge-primary"
          v-if="bid.rfqData.quote.status === 3 && bid.rfqData.quote.rank && $hasPermission('view_rank')">
          Rank #{{ bid.rfqData.quote.rank }}
        </span>
        <span
          class="link-action"
          :class="getAction.class"
          v-if="true"
          @click="$emit('showActions')"
        >
          <svgicon name="bid-quote" width="10" height="10" />
          <span v-if="isFilterClosed">{{ getAction.label }}</span>
        </span>
      </Col>
    </Row>
  </div>
</template>
<script>
import { bidsActions } from '@/constants/indentConstants';
import getRoute from '@/lib/Route';
import moment from 'moment';

export default {
  props: {
    bid: {
      type: Object,
      default: () => {},
    },
    sectionHeader: {
      type: Array,
      default: () => [],
    },
    isFilterClosed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      bidsActions,
      vehicleType: [],
      vehicleShortForm: null,
    };
  },
  methods: {
  },
  computed: {
    getBidDetails() {
      const bidDetails = {
        order_no: this.bid.order_no,
        created_at: moment(this.bid.created_at).format('DD MMM YYYY'),
        route: getRoute(this.bid.sources, this.bid.destinations),
        vehicle_type: this.bid.vehicle_type && this.bid.vehicle_type.short_form,
        vechile_req_date:
          this.bid.rfqData &&
          moment(this.bid.rfqData.loading_date).format('DD MMM YYYY | hh:mm A'),
        expires_at:
          this.bid.rfqData &&
          moment(this.bid.rfqData.expires_at).format('DD MMM YYYY | hh:mm A'),
      };
      return bidDetails;
    },
    hasRequestedVehicle() {
      return (this.bid.rfqData.requested_vehicle && this.bid.rfqData.requested_vehicle.id);
    },
    requestedVehicle() {
      return this.bid.rfqData.requested_vehicle;
    },
    getAction() {
      return this.bidsActions.find(
        action => action.id === this.bid.rfqData.quote.status,
      );
    },
  },
};
</script>
